import { useSelector } from "react-redux";

import useActionAfterFlagChange from "app/pages/sales-intelligence/hooks/useActionAfterFlagChange";
import advancedSearchSessionStorage from "app/pages/sales-intelligence/sub-modules/advanced-search/services/storage/session-storage/storage";
import { selectExcelDownloading } from "app/pages/sales-intelligence/sub-modules/advanced-search/store/selectors";
import { selectExportingToDynamics } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/dynamics/exportSelectors";
import { selectHsExportingTo } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/hubspot/exportSelectors";
import { selectExportingToSF } from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";

const useExportSearchTrigger = (callback: VoidFunction, condition = true) => {
    const isExportingToSF = useSelector(selectExportingToSF);
    const isExportingToHS = useSelector(selectHsExportingTo);
    const isExportingToDynamics = useSelector(selectExportingToDynamics);
    const isExportingToExcel = useSelector(selectExcelDownloading);

    const isExportInProgress = isExportingToSF || isExportingToHS || isExportingToDynamics || isExportingToExcel;

    useActionAfterFlagChange(
        isExportInProgress,
        () => {
            const shouldTriggerActivate = advancedSearchSessionStorage.getExportTriggerShouldActivate();

            if (shouldTriggerActivate) {
                callback();

                advancedSearchSessionStorage.setExportTriggerShouldActivate(false);
            }
        },
        !isExportInProgress && condition,
    );
};

export default useExportSearchTrigger;
